import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full overflow-y-auto no-scrollbar pt-6 xl:pt-[104px] max-md:bg-beige flex flex-col items-center px-4" }
const _hoisted_2 = { class: "w-full lg:w-[812px]" }
const _hoisted_3 = { class: "py-6 w-full lg:w-[812px]" }

import { ref } from "vue";
import { BaziPredictionRequest, BaziResponse } from "@/types/calculators";
import { fetchBaziPrediction } from "@/api/calculators";
import BaziPredictionForm from "@/views/Calculators/BaZiPrediction/components/BaziPredictionForm.vue";
import BaziPredictionResult from "@/views/Calculators/BaZiPrediction/components/BaziPredictionResult.vue";
import PageTitleWithBackButton from "@/components/PageTitleWithBackButton.vue";
import { useI18n } from "vue-i18n";
import AccordionFaq from "@/components/accordion/AccordionFAQ.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaziPredictionView',
  setup(__props) {

const { t } = useI18n();

const baziResponse = ref<BaziResponse | null>(null);
const inputYear = ref<number | null>(null);
const apiLoading = ref(false);

async function loadBaziPrediction(baziRequest: BaziPredictionRequest) {
  if (apiLoading.value) {
    return;
  }
  apiLoading.value = true;
  try {
    baziResponse.value = await fetchBaziPrediction(baziRequest);
    inputYear.value = new Date(baziRequest.date).getFullYear();
  } finally {
    apiLoading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PageTitleWithBackButton, {
        "page-title": _unref(t)('calculators.bazi.title'),
        "title-align": 'left',
        class: _normalizeClass({ 'xl:!flex': baziResponse.value }),
        "on-back": () => (baziResponse.value = null)
      }, null, 8, ["page-title", "class", "on-back"]),
      (baziResponse.value)
        ? (_openBlock(), _createBlock(BaziPredictionResult, {
            key: 0,
            data: baziResponse.value,
            "input-year": inputYear.value
          }, null, 8, ["data", "input-year"]))
        : (_openBlock(), _createBlock(BaziPredictionForm, {
            key: 1,
            loading: apiLoading.value,
            onSubmit: loadBaziPrediction
          }, null, 8, ["loading"]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(AccordionFaq, {
        faqTemplateName: "faq.bazi.content",
        title: "FAQ",
        collapseButtonText: _unref(t)('faq.bazi.collapse-button')
      }, null, 8, ["collapseButtonText"])
    ])
  ]))
}
}

})